import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { loginApi } from '../http/http';
import normalizeMsisdn from '../utils/normalizeMsisdn';
import toast, { Toaster } from 'react-hot-toast';
import classes from './LoginPage.module.css';

const LoginPage = () => {
    const [phone, setPhone] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const navigate = useNavigate();

    const handleLogin = async (e) => {
        e.preventDefault();
        setError('');

        const normalizedMsisdn = normalizeMsisdn(phone);
        if (!normalizedMsisdn) {
            setError('Please enter a valid Nigerian mobile number');
            return;
        }

        setLoading(true);
        try {
            const response = await loginApi(normalizedMsisdn);
            const loginData = response.data?.data || {};
            localStorage.setItem('token', loginData.token);
            localStorage.setItem('userData', JSON.stringify(loginData.user || { msisdn: normalizedMsisdn }));
            navigate('/', { replace: true });
        } catch (err) {
            const statusCode = err.response?.status;
            const message = err.response?.data?.message || 'Unable to check subscription status.';

            if (statusCode === 404 || statusCode === 400 || statusCode === 403) {
                handleNotSubscribed();
                return;
            }

            setError(message);
            toast.error(message);
            setLoading(false);
        }
    };

    const handleNotSubscribed = () => {
        setError('User not subscribed. Please subscribe first.');
        toast.error('User not subscribed. Please subscribe first!');
        setLoading(false);
        setTimeout(() => {
            navigate('/subscribe');
        }, 1500);
    };

    return (
        <div className={classes.page_wrapper}>
            <Toaster position="top-center" reverseOrder={false} />
            <div className={classes.bg_blob_1}></div>
            <div className={classes.bg_blob_2}></div>

            <div className={classes.card}>
                <div className={classes.logo_area}>
                    <div className={classes.logo_icon_wrap}>
                        <img src="/assets/images/logo.png" alt="logo" className={classes.logo_icon} />
                    </div>
                    <p className={classes.logo_text}>Game<span>Plex</span></p>
                </div>

                <div className={classes.heading_area}>
                    <h1 className={classes.title}>Welcome back</h1>
                    <p className={classes.subtitle}>Sign in with your mobile number to continue</p>
                </div>

                <form className={classes.form} onSubmit={handleLogin}>
                    <div>
                        <span className={classes.field_label}>Mobile Number</span>
                        <div className={classes.input_group}>
                            <span className={classes.input_prefix}>+234</span>
                            <input
                                className={classes.input}
                                type="tel"
                                placeholder="8012345678"
                                value={phone}
                                onChange={(e) => setPhone(e.target.value.replace(/\D/g, ''))}
                                maxLength={14}
                                disabled={loading}
                            />
                        </div>
                    </div>

                    {error && <p className={classes.error_msg} style={{color: '#ff4d4d', fontSize: '13px', marginTop: '8px'}}>{error}</p>}

                    <button type="submit" className={classes.submit_btn} disabled={loading}>
                        {loading ? 'Checking Status...' : 'Login'}
                    </button>
                </form>

                <p className={classes.register_row}>
                    Don't have an account?{' '}
                    <button type="button" className={classes.register_link} onClick={() => navigate('/subscribe')}>
                        Subscribe Now
                    </button>
                </p>

                <p className={classes.terms_text}>
                    By continuing, you agree to our <span onClick={() => navigate('/privacy-policy')} className={classes.terms_link} style={{cursor: 'pointer'}}>Terms and Conditions</span>
                </p>
            </div>
        </div>
    );
};

export default LoginPage;